import { render } from "./CardWidget.vue?vue&type=template&id=647f8900"
import script from "./CardWidget.vue?vue&type=script&lang=js"
export * from "./CardWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__